import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';

import LandingPage from './components/LandingPage';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Perforaciones from './components/Perforaciones';
import Desarrollo from './components/Desarrollo';
import Contacto from './components/Contacto';
import Compresor from './components/Compresor';
import Historia from './components/Historia';

function App() {
  return (
    <Router> {/* Sin basename, porque estás en el root */}
      <div>
        <Navbar />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/perforaciones" element={<Perforaciones />} />
          <Route path="/desarrollo" element={<Desarrollo />} />
          <Route path="/compresor" element={<Compresor />} />
          <Route path="/contacto" element={<Contacto />} />
          <Route path="/historia" element={<Historia />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;